import React, { useState } from 'react';
import HelmetMeta from './ai-agents/HelmetMeta';

const JobrockPublic: React.FC = () => {
  const [OgMeta, setOgMeta] = useState<any>({
      title: "Jobrock Public",
      description: "This is public page for jobrock",
      image: "",
    });
  
  return (
    <>
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl mb-4">JobrockPublic</h1>
      <p className="text-lg text-gray-600">The page you're looking is public page for Jobrock</p>
    </div>
    {OgMeta.title && OgMeta.description && (
          <HelmetMeta title={OgMeta.title} description={OgMeta.description} image={OgMeta.image} />
        )}
    </>
  );
};

export default JobrockPublic;
